var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"cu-option",class:{active: _vm.selected},on:{"click":function($event){$event.stopPropagation();return _vm.handleClick($event)}}},[_c('span',[_vm._v(_vm._s(_vm.showLabel))])])}
var staticRenderFns = []

export { render, staticRenderFns }